"use client";

import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { InfoBox } from "../InfoBox/InfoBox";
import { BundleProductAccordion } from "./BundleProductAccordion/BundleProductAccordion";
import { RetiredStaticBundleComponent } from "../../types/types";
import styles from "./BundleProductsList.module.scss";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

type Props = {
  /**
   * An array of RetiredStaticBundleComponent objects representing the bundle components.
   */
  bundleComponents: RetiredStaticBundleComponent[];
  /**
   * A function that handles navigation, taking a string path as an argument.
   */
  navigate: (path: string) => void;
};

export const BundleProductsListUI = ({ bundleComponents, navigate }: Props) => {
  const numberOfComponents = bundleComponents.length;

  return (
    <div data-testid="bundleProductsList" data-component="BundleProductsList">
      {bundleComponents.map((component, index) => (
        <section
          data-testid={`bundleProduct-${index + 1}`}
          key={`bundleItem-${index}`}
          className={styles["bundle-product"]}
        >
          <h2 className={styles.bundleItemTitle}>
            Bundle item {index + 1} of {numberOfComponents}
          </h2>
          <div data-testid={`bundleProduct-image-${index + 1}`}>
            <a href={`${component.variant.parentProduct.pdpURL.url}`}>
              <img
                src={formatAmplienceImageURL(
                  `${component.variant.images.primary}?$rsp-pdp-thmb$`,
                )}
                alt={component.variant.title}
              />
            </a>
          </div>
          <div className={styles.variantDetails}>
            <div data-testid={`bundleProduct-title-${index + 1}`}>
              <a href={`${component.variant.parentProduct.pdpURL.url}`}>
                <h3>{component.variant.title}</h3>
              </a>
            </div>
            {!component.isActiveComponent && (
              <div data-testid={`bundleProduct-infoBox-${index + 1}`}>
                <InfoBox />
              </div>
            )}
            {component.isActiveComponent && (
              <div data-testid={`bundleProduct-view-product-link-${index + 1}`}>
                <UnderlinedButton
                  tag="a"
                  href={`${component.variant.parentProduct.pdpURL.url}`}
                  onClick={() =>
                    navigate(`${component.variant.parentProduct.pdpURL.url}`)
                  }
                >
                  View individual product
                </UnderlinedButton>
              </div>
            )}
          </div>
          <div data-testid={`bundleProduct-accordion-${index + 1}`}>
            <BundleProductAccordion bundleComponent={component} />
          </div>
        </section>
      ))}
    </div>
  );
};
